import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next'; // 1. Importar hooks
import './GaleriaPage.css';

import galleryHeroImg from '../../../assets/Galeria.Hero.png';

//imagenes de habitaciones
import img1 from '../../../assets/1 Bungalow Cielo.png';
import img2 from '../../../assets/2 Vista Mar.png';
import img3 from '../../../assets/3 Bungalow Arena.png';
import img4 from '../../../assets/4 Vista Mar.png';
import img5 from '../../../assets/5 Suite Luna de Miel.png';
import img6 from '../../../assets/6 Bungalow Cielo.png';
import img7 from '../../../assets/7 Vista Mar.png';
import img8 from '../../../assets/8 Master Suite Palapa.png';
import img9 from '../../../assets/9 Suite Luna de Miel.png';
import img10 from '../../../assets/10 Bungalow Arena.png';
import img11 from '../../../assets/11 Vista Mar.png';
import img12 from '../../../assets/12 Vista Mar.png';
import img13 from '../../../assets/13 Bungalow Jardin.png';
import img14 from '../../../assets/14 Vista Mar.png';
import img15 from '../../../assets/15 Cacao.png';
import img16 from '../../../assets/16 Master Suite Palapa.png';
import img17 from '../../../assets/17 Bungalow Jardin.png';
import img18 from '../../../assets/18 Grand Villa.png';

//imagenes del hotel
import img19 from '../../../assets/1.png';
import img20 from '../../../assets/2.png';
import img21 from '../../../assets/3.png';
import img22 from '../../../assets/4.png';
import img23 from '../../../assets/5.png';
import img24 from '../../../assets/6.png';
import img25 from '../../../assets/7.png';
import img26 from '../../../assets/8.png';
import img27 from '../../../assets/9.png';
import img28 from '../../../assets/10.png';
import img29 from '../../../assets/11.png';
import img30 from '../../../assets/12.png';
import img31 from '../../../assets/13.png';
import img32 from '../../../assets/14.png';
import img33 from '../../../assets/15.png';
import img34 from '../../../assets/16.png';
import img35 from '../../../assets/17.png';
import img36 from '../../../assets/18.png';
import img37 from '../../../assets/19.png';
import img38 from '../../../assets/20.png';
import img39 from '../../../assets/21.png';
import img40 from '../../../assets/22.png';
import img41 from '../../../assets/23.png';
import img42 from '../../../assets/24.png';
import img43 from '../../../assets/25.png';
import img44 from '../../../assets/26.png';
import img45 from '../../../assets/27.png';
import img46 from '../../../assets/28.png';
import img47 from '../../../assets/29.png';
import img48 from '../../../assets/30.png';
import img49 from '../../../assets/31.png';
import img50 from '../../../assets/32.png';
import img51 from '../../../assets/33.png';
import img52 from '../../../assets/34.png';
import img53 from '../../../assets/35.png';
import img54 from '../../../assets/36.png';
import img55 from '../../../assets/37.png';
import img56 from '../../../assets/38.png';
import img57 from '../../../assets/39.png';
import img58 from '../../../assets/40.png';
import img59 from '../../../assets/41.png';
import img60 from '../../../assets/42.png';
import img61 from '../../../assets/43.png';
import img62 from '../../../assets/44.png';
import img63 from '../../../assets/45.png';
import img64 from '../../../assets/46.png';
import img65 from '../../../assets/47.png';
import img66 from '../../../assets/48.png';
import img67 from '../../../assets/49.png';
import img68 from '../../../assets/50.png';
import img69 from '../../../assets/51.png';
import img70 from '../../../assets/52.png';
import img71 from '../../../assets/53.png';
import img72 from '../../../assets/54.png';
import img73 from '../../../assets/55.png';

const galleryData = [
  // --- INICIO DEL PATRÓN ALTERNADO (Habitación / Hotel) ---
  { id: 1, src: img1, alt: 'Bungalow Cielo', category: 'habitaciones' },
  { id: 2, src: img19, alt: 'Vista del hotel', category: 'hotel' },
  { id: 3, src: img2, alt: 'Vista Mar', category: 'habitaciones' },
  { id: 4, src: img20, alt: 'Instalaciones del hotel', category: 'hotel' },
  { id: 5, src: img3, alt: 'Bungalow Arena', category: 'habitaciones' },
  { id: 6, src: img21, alt: 'Áreas comunes', category: 'hotel' },
  { id: 7, src: img4, alt: 'Vista Mar', category: 'habitaciones' },
  { id: 8, src: img22, alt: 'Vista del hotel', category: 'hotel' },
  { id: 9, src: img5, alt: 'Suite Luna de Miel', category: 'habitaciones' },
  { id: 10, src: img23, alt: 'Paisaje del hotel', category: 'hotel' },
  { id: 11, src: img6, alt: 'Bungalow Cielo', category: 'habitaciones' },
  { id: 12, src: img24, alt: 'Vista del hotel', category: 'hotel' },
  { id: 13, src: img7, alt: 'Vista Mar', category: 'habitaciones' },
  { id: 14, src: img25, alt: 'Instalaciones', category: 'hotel' },
  { id: 15, src: img8, alt: 'Master Suite Palapa', category: 'habitaciones' },
  { id: 16, src: img26, alt: 'Vista del hotel', category: 'hotel' },
  { id: 17, src: img9, alt: 'Suite Luna de Miel', category: 'habitaciones' },
  { id: 18, src: img27, alt: 'Áreas verdes', category: 'hotel' },
  { id: 19, src: img10, alt: 'Bungalow Arena', category: 'habitaciones' },
  { id: 20, src: img28, alt: 'Vista del hotel', category: 'hotel' },
  { id: 21, src: img11, alt: 'Vista Mar', category: 'habitaciones' },
  { id: 22, src: img29, alt: 'Instalaciones', category: 'hotel' },
  { id: 23, src: img12, alt: 'Vista Mar', category: 'habitaciones' },
  { id: 24, src: img30, alt: 'Vista del hotel', category: 'hotel' },
  { id: 25, src: img13, alt: 'Bungalow Jardin', category: 'habitaciones' },
  { id: 26, src: img31, alt: 'Áreas comunes', category: 'hotel' },
  { id: 27, src: img14, alt: 'Vista Mar', category: 'habitaciones' },
  { id: 28, src: img32, alt: 'Vista del hotel', category: 'hotel' },
  { id: 29, src: img15, alt: 'Cacao', category: 'habitaciones' },
  { id: 30, src: img33, alt: 'Instalaciones', category: 'hotel' },
  { id: 31, src: img16, alt: 'Master Suite Palapa', category: 'habitaciones' },
  { id: 32, src: img34, alt: 'Vista del hotel', category: 'hotel' },
  { id: 33, src: img17, alt: 'Bungalow Jardin', category: 'habitaciones' },
  { id: 34, src: img35, alt: 'Áreas verdes', category: 'hotel' },
  { id: 35, src: img18, alt: 'Grand Villa', category: 'habitaciones' },
  { id: 36, src: img36, alt: 'Vista del hotel', category: 'hotel' },

  
  // --- IMAGENES DEL HOTEL ---
  { id: 37, src: img37, alt: 'Vista del hotel', category: 'hotel' },
  { id: 38, src: img38, alt: 'Instalaciones', category: 'hotel' },
  { id: 39, src: img39, alt: 'Vista del hotel', category: 'hotel' },
  { id: 40, src: img40, alt: 'Áreas comunes', category: 'hotel' },
  { id: 41, src: img41, alt: 'Vista del hotel', category: 'hotel' },
  { id: 42, src: img42, alt: 'Instalaciones', category: 'hotel' },
  { id: 43, src: img43, alt: 'Vista del hotel', category: 'hotel' },
  { id: 44, src: img44, alt: 'Áreas verdes', category: 'hotel' },
  { id: 45, src: img45, alt: 'Vista del hotel', category: 'hotel' },
  { id: 46, src: img46, alt: 'Instalaciones', category: 'hotel' },
  { id: 47, src: img47, alt: 'Vista del hotel', category: 'hotel' },
  { id: 48, src: img48, alt: 'Áreas comunes', category: 'hotel' },
  { id: 49, src: img49, alt: 'Vista del hotel', category: 'hotel' },
  { id: 50, src: img50, alt: 'Instalaciones', category: 'hotel' },
  { id: 51, src: img51, alt: 'Vista del hotel', category: 'hotel' },
  { id: 52, src: img52, alt: 'Áreas verdes', category: 'hotel' },
  { id: 53, src: img53, alt: 'Vista del hotel', category: 'hotel' },
  { id: 54, src: img54, alt: 'Instalaciones', category: 'hotel' },
  { id: 55, src: img55, alt: 'Vista del hotel', category: 'hotel' },
  { id: 56, src: img56, alt: 'Áreas comunes', category: 'hotel' },
  { id: 57, src: img57, alt: 'Vista del hotel', category: 'hotel' },
  { id: 58, src: img58, alt: 'Instalaciones', category: 'hotel' },
  { id: 59, src: img59, alt: 'Vista del hotel', category: 'hotel' },
  { id: 60, src: img60, alt: 'Áreas verdes', category: 'hotel' },
  { id: 61, src: img61, alt: 'Vista del hotel', category: 'hotel' },
  { id: 62, src: img62, alt: 'Instalaciones', category: 'hotel' },
  { id: 63, src: img63, alt: 'Vista del hotel', category: 'hotel' },
  { id: 64, src: img64, alt: 'Áreas comunes', category: 'hotel' },
  { id: 65, src: img65, alt: 'Vista del hotel', category: 'hotel' },
  { id: 66, src: img66, alt: 'Instalaciones', category: 'hotel' },
  { id: 67, src: img67, alt: 'Vista del hotel', category: 'hotel' },
  { id: 68, src: img68, alt: 'Áreas verdes', category: 'hotel' },
  { id: 69, src: img69, alt: 'Vista del hotel', category: 'hotel' },
  { id: 70, src: img70, alt: 'Instalaciones', category: 'hotel' },
  { id: 71, src: img71, alt: 'Vista del hotel', category: 'hotel' },
  { id: 72, src: img72, alt: 'Áreas comunes', category: 'hotel' },
  { id: 73, src: img73, alt: 'Vista del hotel', category: 'hotel' },
];

type FilterType = 'todos' | 'hotel' | 'habitaciones';

const GaleriaPage: React.FC = () => {
 
  useTranslation(); 
  
  const [activeFilter, setActiveFilter] = useState<FilterType>('hotel');
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);

  const filteredImages = useMemo(() => {
    if (activeFilter === 'todos') return galleryData;
    
    return galleryData.filter((img) => img.category === activeFilter);
  }, [activeFilter]);

  /* Lightbox handlers */
  const openLightbox = (index: number) => {
    setSelectedImageIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImageIndex(null);
  };

  const showNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImageIndex !== null) {
      setSelectedImageIndex((prev) => (prev !== null && prev < filteredImages.length - 1 ? prev + 1 : 0));
    }
  };

  const showPrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImageIndex !== null) {
      setSelectedImageIndex((prev) => (prev !== null && prev > 0 ? prev - 1 : filteredImages.length - 1));
    }
  };

  // Keyboard navigation
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (selectedImageIndex === null) return;
    
    if (e.key === 'Escape') {
      closeLightbox();
    } else if (e.key === 'ArrowRight') {
      setSelectedImageIndex((prev) => (prev !== null && prev < filteredImages.length - 1 ? prev + 1 : 0));
    } else if (e.key === 'ArrowLeft') {
      setSelectedImageIndex((prev) => (prev !== null && prev > 0 ? prev - 1 : filteredImages.length - 1));
    }
  }, [selectedImageIndex, filteredImages]);

  useEffect(() => {
    if (selectedImageIndex !== null) {
      document.body.style.overflow = 'hidden'; // Prevent scrolling when lightbox is open
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'auto';
    };
  }, [selectedImageIndex, handleKeyDown]);

  return (
    <div className="gallery-page-container">
      {/* ... header ... */}
      <header 
        className="gallery-hero"
        style={{ backgroundImage: `url(${galleryHeroImg})` }}
      >
        <div className="gallery-hero-overlay"></div>
        <h1 className="gallery-hero-title">
         
          <Trans i18nKey="gallery:title" />
        </h1>
      </header>
     
      <section className="gallery-content">
       
        <div className="gallery-filters-box">
         <div className="gallery-filters">

          <button 
            className={`filter-btn ${activeFilter === 'todos' ? 'active' : ''}`}
            onClick={() => setActiveFilter('todos')}
            style={{display:'none'}}          >
             {/* 4. Filtro Todos */}
            <Trans i18nKey="gallery:filters.all" />
          </button>

          <button 
            className={`filter-btn ${activeFilter === 'hotel' ? 'active' : ''}`}
            onClick={() => setActiveFilter('hotel')}
          >
            {/* 5. Filtro Hotel */}
            <Trans i18nKey="gallery:filters.hotel" />
          </button>

          <button 
            className={`filter-btn ${activeFilter === 'habitaciones' ? 'active' : ''}`}
            onClick={() => setActiveFilter('habitaciones')}
          >
            {/* 6. Filtro Habitaciones */}
            <Trans i18nKey="gallery:filters.rooms" />
          </button>
          </div>
        </div>
        
        <div className="linea-global"></div>
        
        <div className="gallery-grid">
           {filteredImages.map((image, index) => (
             <div key={image.id} className="gallery-item-wrapper" onClick={() => openLightbox(index)}>
                {activeFilter !== 'hotel' && (
                  <p>{image.alt}</p>
                )}
                <img src={image.src} alt={image.alt} className="gallery-image" loading="lazy" />
                <div className="gallery-item-overlay"></div>
             </div>
           ))}
        </div>

        {filteredImages.length === 0 && (
          // 7. Mensaje de error (por si acaso)
          <p className="no-images-msg">
            <Trans i18nKey="gallery:noImages" />
          </p>
        )}

      </section>

      {/* Lightbox Overlay */}
      {selectedImageIndex !== null && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <button className="lightbox-close-btn" onClick={closeLightbox}>
            &times;
          </button>
          
          <button className="lightbox-nav-btn prev" onClick={showPrev}>
            &#10094;
          </button>
          
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={filteredImages[selectedImageIndex].src} 
              alt={filteredImages[selectedImageIndex].alt} 
              className="lightbox-image" 
            />
            {filteredImages[selectedImageIndex].alt && (
               <p className="lightbox-caption">{filteredImages[selectedImageIndex].alt}</p>
            )}
          </div>

          <button className="lightbox-nav-btn next" onClick={showNext}>
            &#10095;
          </button>
        </div>
      )}
    </div>
  );
};

export default GaleriaPage;